import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const salesmanLinkingSchema = yup.object().shape({
  ifrea_analytics_salesman_id: yup.string().required('入力必須項目です'),
});
export const useRegisterSalesmanLinkingForm = () => {
  const { handleSubmit, register, formState: { errors, isSubmitting } } = useForm({resolver: yupResolver( salesmanLinkingSchema),});
  return {
    handleSubmit,
    register,
    isSubmitting,
    errors,
  };
};